import axios from "axios";
import {ActionTree} from "vuex";
import {SystemUserFilter, SystemUserItem, SystemUsersState} from "@/store/user_management/system_users/types";
import {RootState} from "@/store/types";
import {directDownload} from "@/utils/download-helper";
import {AllowedPage} from "@/store/user_management/roles/types";

export const actions: ActionTree<SystemUsersState, RootState> = {
    getSystemPages: ({commit}, data) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: '/acapi/system_users/pages', params: data})
                .then(resp => {
                    resp.data?.pages?.map((page:AllowedPage)=> {
                        page.allowed = true
                    });
                    commit('setSystemPages', resp.data.pages);
                    resolve(resp?.data.pages ?? [])
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    getSystemUsers: ({commit}, data: SystemUserFilter) => {
        // commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: '/acapi/system_users', params: data})
                .then(resp => {
                    if (data?.page_number > 1) {
                        commit("pushSystemUsers", resp.data.system_users);
                    } else {
                        commit('setSystemUsers', resp.data.system_users);
                    }
                    resolve(resp.data.system_users)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    getSystemUserItem: ({commit}, id: number) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: `/acapi/system_users/${id}`})
                .then((resp: any) => {
                    let systemUserItem = <SystemUserItem>resp.data;
                    systemUserItem.id = id;
                    commit('setSystemUserItem', systemUserItem);
                    resolve(systemUserItem)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    saveSystemUser: ({commit, dispatch}, data: SystemUserItem) => {
        commit('setLoading', true);
      // Тут такое не разбериха нужно было добавить header при изменении ролей
      axios.defaults.headers["Request-Change-Permissions"] = true;
      return new Promise((resolve, reject) => {
            data.system_pages?.filter(value => !value.allowed).map(value => value.allowed = false)
            axios({
                method: data.id ? 'put' : 'post',
                url: '/acapi/system_users/' + (data.id ?? ''),
                data: data
            })
                .then((resp: any) => {
                    dispatch('getSystemUsers');
                    resolve(resp)
                })
                .catch((err: any) => {
                    // errorNotify(err);
                    reject(err)
                })
                .finally(() => {
                  // соответственно я его удаляю
                  delete axios.defaults.headers["Request-Change-Permissions"]
                  commit('setLoading', false)
                })
        })
    },
    deleteSystemUser: ({commit, dispatch}, data: SystemUserItem) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                method: 'delete',
                url: `/acapi/system_users/${data.id}`,
                data: data
            })
                .then((resp: any) => {
                    dispatch('getSystemUsers');
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    exportSystemUsers: ({commit, dispatch}, data: SystemUserFilter) => {
        return directDownload('/acapi/system_users/export', data)
    },
    changePassword: async ({commit, dispatch}, data: any) => {
        let actionLogData = {
            action_page: "menu.item.login",
            action: "Password change",
            object_type: "System user",
        }
        return new Promise((resolve, reject)=>{
            axios({
                method: 'post',
                url: '/acapi/system_users/current/change_password',
                data: data
            }).then((res: any)=>{
                commit('setChangePassword', false);
                localStorage.setItem('incp', 'false');
                dispatch('actionLog', {...actionLogData, action_status: "success"});
                resolve(res);
            }).catch((err:any)=>{
                dispatch('actionLog', {...actionLogData, action_status: "failed"});
                reject(err);
            })
        })
    },
}
